import { render, staticRenderFns } from "./CGasProduce.vue?vue&type=template&id=654aa1b0"
import script from "./CGasProduce.vue?vue&type=script&lang=js"
export * from "./CGasProduce.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports